import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React from "react";
import { FaBackward, FaDownload, FaForward, FaMinus, FaPlus } from "react-icons/fa";
import { Button } from "../../../button";
/**
 *
 * @param {object} props
 * @param {() => any} props.onZoomIn
 * @param {() => any} props.onZoomOut
 * @param {() => any} props.onDownload
 * @param {() => any} props.onNext
 * @param {() => any} props.onPrevious
 * @param {number} props.scale
 * @param {number} props.page
 * @param {number} props.total
 * @param {string} props.src
 * @param {any} props.className
 */

export const PdfControls = ({
  onZoomIn,
  onZoomOut,
  onDownload,
  onNext,
  onPrevious,
  scale,
  page,
  total,
  src,
  className
}) => {
  const controlClassName = classNames("", className);

  const next = async () => {
    if (page < total) {
      onNext();
    }
  };

  const previous = async () => {
    if (page > 1) {
      onPrevious();
    }
  };

  const zoomIn = async () => {
    onZoomIn();
  };

  const zoomOut = async () => {
    if (scale > 0.8) {
      onZoomOut();
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: controlClassName
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full block opacity-25 hover:opacity-50"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inline-block w-1/5 align-top"
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "dark",
    onClick: previous,
    title: "Previous Page"
  }, /*#__PURE__*/React.createElement(FaBackward, null))), /*#__PURE__*/React.createElement("div", {
    className: "inline-block w-3/5 text-center relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inline-block w-48 rounded"
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "dark",
    className: "",
    onClick: zoomIn,
    title: "Zoom In"
  }, /*#__PURE__*/React.createElement(FaPlus, null)), /*#__PURE__*/React.createElement(Button, {
    theme: "dark",
    className: "mx-1",
    onClick: zoomOut,
    title: "Zoom Out"
  }, /*#__PURE__*/React.createElement(FaMinus, null)), /*#__PURE__*/React.createElement(Button, {
    theme: "dark",
    className: "inline-block align-top",
    onClick: () => onDownload(),
    title: "Download",
    as: "a",
    download: true,
    href: src
  }, /*#__PURE__*/React.createElement(FaDownload, null))), /*#__PURE__*/React.createElement("p", {
    className: "absolute left-0 right-0"
  }, page, " of ", total)), /*#__PURE__*/React.createElement("div", {
    className: "inline-block w-1/5 align-top text-right"
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "dark",
    onClick: next,
    title: "Next Page"
  }, /*#__PURE__*/React.createElement(FaForward, null)))));
};
PdfControls.propTypes = {
  onZoomIn: PropTypes.func,
  onZoomOut: PropTypes.func,
  onDownload: PropTypes.func,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  scale: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  src: PropTypes.string,
  className: PropTypes.any
};